import { ConvexReactClient } from 'convex/react'
import { createDurableAuthStorage, createLocalAuth } from '@platform/auth/web'

/**
 * The Convex Auth side of the web client, from @platform/auth.
 *
 * Rendering gates on the LOCAL signal (`localAuth.useLocalAuth`): the auth
 * provider flips authenticated the moment it reads the JWT from storage,
 * which works offline; the server-confirmed signal is only for issuing authed
 * side effects. Storage dual-writes localStorage and IndexedDB so a session
 * survives an evicted localStorage; explicit sign-out purges both tiers.
 *
 * The legacy opaque token (`getToken` in ConvexSync) remains a parallel
 * sign-in state until every active device has rotated; anything gating on
 * "signed in" checks both.
 */

export const AUTH_STORAGE_NAMESPACE = 'aurora'

export const localAuth = createLocalAuth(AUTH_STORAGE_NAMESPACE)

export const durableAuth = createDurableAuthStorage({ dbName: 'aurora-auth' })

const CONVEX_URL = import.meta.env.VITE_CONVEX_URL ?? ''

/**
 * The one React client behind ConvexAuthProvider. Auth flows (sign in, sign
 * up, the authed account mutations) go through it; the synced store keeps its
 * own ConvexClient in ConvexSync, authed with the same JWT.
 *
 * Without a Convex URL (screenshot runs, the local demo) the client points at
 * a placeholder and never connects — it exists so the auth provider and its
 * hooks are always mounted, keeping every component hook-safe.
 */
export const authReactClient = new ConvexReactClient(
  CONVEX_URL || 'https://local-demo.invalid',
  { skipConvexDeploymentUrlCheck: true },
)
